<template>
  <div class="dataTable__actions d-flex justify-content-end gap-2">
    <template v-for="(action, index) in actions" :key="index">
      <template v-if="isActionVisible(action)">
        <ButtonComponent
          v-if="action.type === 'button'"
          :icon="action.icon"
          :tooltip="action.tooltip"
          :text="action.text"
          :className="action.className"
          @buttonClick="clickAction(action)"
        />
        <RouterLinkComponent
          v-else-if="action.type === 'router'"
          :routeName="action.action"
          :tooltip="action.tooltip"
          :icon="action.icon"
          :params="setActionParams(action)"
          :className="action.className"
          @click="clickAction(action)"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { dataTableManager } from "@/services/data-table/data-table-manager";
import ButtonComponent from "@/components/utils/buttons/ButtonComponent.vue";
import RouterLinkComponent from "@/components/utils/buttons/RouterLinkComponent.vue";

export default {
  name: "ActionCellDataTableComponent",
  components: { RouterLinkComponent, ButtonComponent },
  props: {
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
    row: {
      type: Object,
      required: true,
    },
  },
  emits: ["clickAction"],
  computed: {},
  methods: {
    clickAction(action) {
      const params = this.setActionParams(action);
      this.$emit("clickAction", { action: action.action, params: params });
    },

    setActionParams(action) {
      return dataTableManager.setRowActionParams(action, this.row);
    },

    isActionVisible(action) {
      return dataTableManager.isRowActionVisible(action, this.row);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  max-height: 40px;
}
</style>
